export const WarehouseTargetData = {
  totalRecords: 333,
  totalPages: 34,
  pageSize: 10,
  currentPage: 0,
  activeCount: 15,
  data: [
    {
      id: 123,
      warehouseId: 215928,
      warehouseName: 'Warehouse Test',
      deliveryService: 22,
      deliveryDays: 'Monday, Wednesday',
      cutOffTime: '11:00',
      businessCategory: 'Snacks',
      creationDate: '2025-09-18 12:34:01',
      lastUpdated: '2025-10-18 12:34:01',
    },
    {
      id: 124,
      warehouseId: 215925,
      warehouseName: 'Warehouse Test1',
      deliveryService: 24,
      deliveryDays: 'Monday, Tuesday, Wednesday',
      cutOffTime: '10:00',
      businessCategory: 'Bevarage',
      creationDate: '2024-09-18 12:34:01',
      lastUpdated: '2024-09-18 12:34:01',
    },
    {
      id: 1245,
      warehouseId: 216925,
      warehouseName: 'Warehouse Test2',
      deliveryService: 20,
      deliveryDays: 'Tuesday, Wednesday',
      cutOffTime: '12:00',
      businessCategory: 'Bevarage',
      creationDate: '2025-10-21 12:34:01',
      lastUpdated: '2024-11-18 12:34:01',
    },
  ],
}
